import React from "react"
import Index from "./Index"
import { contentLayout, modules } from "../config/const"
import { useUser } from "../contexts/UserContext"
import Forbidden from "./Forbidden"

function ViewCashRegister (){
  const {user} = useUser()
  let view = contentLayout[modules.CashRegisterList]
  if(user.permissions.views.length && !user.permissions.views.join().includes(modules.CashRegisterList.toLowerCase())){
    view = Forbidden
  }
  return(
  <Index content={view} module={modules.CashRegisterList}></Index>
 )
}

export default ViewCashRegister
